module.exports = __webpack_public_path__ + "img/player-line.df9c2f16.svg";